import httpService from './http.service';

const fetchTenants = () => httpService
    .get('/tenants')
    .then(({data}) => data)
    .catch((err) => Promise.reject(err));

export default {
    fetchTenants,
};